import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {createStructuredSelector} from "reselect";
import {
    selectCurrentUser
} from "../../redux/selectors/app.selectors";
import {
    selectDevices
} from "../../redux/selectors/device.selector";
import {connect} from "react-redux";
import {compose} from "redux";
import React from "react";
import {useTranslation} from "react-i18next";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "../../components/Controls/Checkbox";
import TextButton from "../../components/Controls/TextButton";
import {Bold, Comment} from "../../utils/style/texts";
import Alert from "../../components/Alert";
import {Flex} from "../../components/Container/Flex";
import { EmailIcon } from "../../utils/icons";
import Button from "../../components/Controls/Button";
import { UserAPI } from "../../utils/API/UserAPI";
import {newTokenAction} from "../../redux/actions/app.actions";
import userMessages from "../../userMessages";

const api = new UserAPI();

const LegacyBandDialog = props => {
    const [t] = useTranslation();
    const {
        currentUser,
        newToken,
        devices
    } = props;
    const isAdmin = currentUser.isAdmin;
    const [showDialog, setShowDialog] = React.useState(!currentUser.acknowledgedMessages[userMessages.LEGACY_BAND_RISKS]);
    const [doNotShowAgain, setDoNotShowAgain] = React.useState(false);
    if(!showDialog) return null;
    if(!currentUser.isAdmin && !currentUser.isPortalUser) return null;
    const affectedDevices = devices?.filter(d => d.affectedBy2GSunset);
    if(!(affectedDevices.size >= 1)) return null;
    
    return (
        <Dialog open maxWidth="md" fullWidth>
            <DialogTitle>
                <Bold>{t('legacyBandDialog.1')}</Bold>
            </DialogTitle>
            <DialogContent>
                <p>{t('legacyBandDialog.2')}</p>
                <p>{t('legacyBandDialog.3')}:</p>
                <ul>
                    {affectedDevices.map(d => (
                        <li key={d.id}>{d.name} <Comment>({d.deviceTypeName(t)})</Comment></li>
                    ))}
                </ul>
                <p>{t('legacyBandDialog.4')}</p>
                {isAdmin ? (
                    <>
                        <p>
                            <Button variant="outlined" onClick={() => window.location = 'mailto:info@vevigo.nl'}
                            ><EmailIcon/>&nbsp;info@vevigo.nl</Button>
                        </p>
                        <Alert type="warning" dismissable={false}>{t('legacyBandDialog.5')}</Alert>
                    </>
                ) : (
                    <Alert type="warning" dismissable={false}>{t('legacyBandDialog.5.user')}</Alert>
                )}
            </DialogContent>
            <DialogActions>

                {isAdmin ? (
                    <Flex align="flex-end">
                        <FormControlLabel
                            style={{marginTop: 20}}
                            control={(
                                <Checkbox
                                    checked={doNotShowAgain}
                                    onChange={() => setDoNotShowAgain(!doNotShowAgain)}
                                />
                            )}
                            label={t('doNotShowThisMessageAgain')}
                        />
                        <TextButton onClick={() => {
                            setShowDialog(false);
                            if(doNotShowAgain) {
                                api.acknowledgeUserMessage(userMessages.LEGACY_BAND_RISKS).then(newToken);
                                localStorage.setItem('hideLegacyBandDialog', true);
                            }
                        }}>{t('close')}</TextButton>
                    </Flex>
                ) : (
                    <TextButton onClick={() => setShowDialog(false)}>{t('close')}</TextButton>
                )}
            </DialogActions>
        </Dialog>
    )
    
}

function mapDispatchToProps(dispatch) {
    return {
        newToken: token => dispatch(newTokenAction(token)),
    };
}

const mapStateToProps = createStructuredSelector({
    currentUser: selectCurrentUser,
    devices: selectDevices,
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(LegacyBandDialog);
